import React from 'react';
import UserLayout from '../components/UserLayout';
import Alerts from '../components/Alerts';

const AlertsPage = () => {
  return (
    <UserLayout>
      <Alerts />
    </UserLayout>
  );
};

export default AlertsPage; 